module.exports = __webpack_public_path__ + "static/born-standing-up-3f115fc07f86422c278e2b14dbe653ab.jpg";